export const CUSTOMER_TITLE = 'Customers';

export const SAVE_CUSTOMER = 'Save Customer';

export const BACK = 'Back to Menu';

export const CUSTOMER_PAGES = {
  TABLE: 'table',
  ADD_CUSTOMER: 'add_customer',
  MANUAL_POINT: 'manual_point',
  CUSTOMER_PROFILE: 'customer_profile',
};

export const CUSTOMER_FIELDS = [
  { id: 'isBlocked', label: 'Status', align: 'center' },
  { id: 'files', label: 'Picture', align: 'center' },
  { id: 'firstName', label: 'First Name', align: 'center' },
  { id: 'lastName', label: 'Last Name', align: 'center' },
  { id: 'points', label: 'Points', align: 'center' },
  { id: 'phone', label: 'Phone', align: 'center' },
  { id: 'dob', label: 'Birth Date', align: 'center' },
  { id: 'registrationDate', label: 'Registration Date', align: 'center' },
  { id: 'lastVisit', label: 'Last Visit', align: 'center' },
];

export const EDIT_CUSTOMER_TOOLTIP = 'Edit Customer';
export const ADD_CUSTOMER_TOOLTIP = 'Add Customer';
